module.exports = __webpack_public_path__ + "static/media/slide6.95ffc08c.jpg";